import React, { useContext, useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import productimage1 from '../../images/product-img-1.jpg'
import productimage2 from '../../images/product-img-2.jpg'
import productimage3 from '../../images/product-img-3.jpg'
import productimage4 from '../../images/product-img-4.jpg'
import { MagnifyingGlass } from 'react-loader-spinner'
import ScrollToTop from "../ScrollToTop";
import api from "../../api";
import Checkout from "../../Component/Checkout";
import { v4 as uuidv4 } from "uuid";
import { CartContext, UserContext, websiteContext } from "../../App";
import { getPaymentGatewayId } from "../../reducers/utils";

const ShopCheckOut = () => {
   const [ params ] = useSearchParams()
   const order_id = params.get("order_id")
   const {user} = useContext(UserContext)
   const [loaderStatus, setLoaderStatus] = useState(true);
   const [orderDetails, setOrderDetails] = useState({})
   const [address, setAddress] = useState(null);
   const [selectedAddress, setSelectedAddress] = useState(null);
   const [selectedPayment, setSelectedPayment] = useState("");
  //  const order_id = "ORD-" + uuidv4().slice(0, 8).toUpperCase();
   const {cart, cartDispatch} = useContext(CartContext)
   const {websiteDetails} = useContext(websiteContext)

   useEffect(() => {
     setTimeout(() => {
       setLoaderStatus(false);
     }, 1500);
   }, []);

     useEffect(() => {
     (async () => {
      const resp = await api.proceedCheckout()
      console.log("checkout",resp)
      setOrderDetails(resp.finalOrder)

       const addressResp = await api.fetchUserAddress()
       console.log("user address",addressResp);
       setAddress(addressResp.address);
      // if (resp.status !== "error") {
      //   // setClientSecret(resp.clientSecret)
      //   setOrderDetails(resp.finalOrder)
      // }
    })();
  }, [])


  const isCod = orderDetails?.products?.every((item => item.product?.cod == true ))
  console.log("cod",isCod)

   const paymentMethods = [
              { id: "card", title: "Credit/Debit Card" ,desc:" Safe money transfer using your bank account."},
              { id: "upi", title: "UPI",desc:" Safe money transfer using your bank UPI account." },
            ];

            if(isCod){
              paymentMethods.push( { id: "cod", title:"COD",desc:"Pay with cash when your order is delivered."})
            }

  const handleAddressSubmit = (e) => {
  e.preventDefault();
  const form = new FormData(e.target);
  const newAddress = {
    name: form.get("name"),
    phone: form.get("phone"),
    area: form.get("area"),
    city: form.get("city"),
    state: form.get("state"),
    country: form.get("country"),
    pincode: form.get("pincode"),
  };

  setAddress(prev => [...prev, newAddress]);
  setSelectedAddress(address?.length);
  console.log("new address",address)
  e.target.reset();
  // setShowAddressForm(false);
};

// console.log("payment",selectedPayment)
// console.log("address",address)
 

const handleCreateOrder = async (txn_id,txnorderId,txnAmount) => {
		const txn_uuid = selectedPayment == "cod" ? "COD-" + uuidv4().slice(0, 8).toUpperCase():txn_id;
		const txn_orderId = selectedPayment == "cod" ? "COD-" + uuidv4().slice(0, 8).toUpperCase():txnorderId;
		const gatewayId = selectedPayment == "cod" ? 0 : getPaymentGatewayId(websiteDetails?.pg_gateways);
		const user = api.getUser()
		
		const resp = await api.createOrder(user,cart.products, cart.total, address[selectedAddress],selectedPayment,order_id,txn_uuid,txn_orderId,orderDetails.couponAmount,orderDetails.delCharge,gatewayId)
		if (resp.status == "ok") {
			console.log("orderid",resp.orderID)
			// setOrderId(resp.orderID)
			//  if (selectedPayment== "cod"){
      //        navigate(`/OrderConfirmation?order_id=${order_id}`,
			// 	{replace:true}
			//  );
      //        }else{
			// 	navigate(`/OrderConfirmation?payment_id=${txn_id}&txnOrder_id=${txnorderId}&order_id=${order_id}&order_total=${txnAmount}`,
      //           {replace:true}
      //           );
			//  }
			await api.clearCart()
			cartDispatch({type: "RESET"})
		}else{
			alert("Order not placed Checkout the product again")
			//  setShowCheckoutModal(false)
		}
	}


  	const handlePayment = async (address,paymentMethod,couponAmount,delCharge) => {
		// setCouponAmount(couponAmount);
		try{
		const total = cart.total + orderDetails.delCharge - orderDetails.couponAmount;
		const key = import.meta.env.VITE_KEY_ID;
		const response = await api.createRazorpayOrder(order_id,user,total,getPaymentGatewayId(websiteDetails?.pg_gateways))
		// console.log("address",address)
		console.log("razorder",response);
		const razOrder = response.razOrder;
		console.log("order",razOrder);
    if(response.success){
        const options = {
        key: key,
        amount: razOrder.amount,	
        currency: "INR",
        // name: "ECOM CLOTHING",
        description: "Payment",
        order_id: razOrder.id,
         handler: async function (response) {
          if (response.razorpay_payment_id) {
            //  console.log("Payment Success Response:", response);
        const apiRes = await api.razorpayPaymentVerify(response,getPaymentGatewayId(websiteDetails?.pg_gateways))
			 console.log("payment verify",apiRes)
        if(apiRes.success){
				handleCreateOrder(
				// address[selectedAddress],
				// selectedPayment,
        // orderDetails.couponAmount,
        // orderDetails.delCharge,
				response.razorpay_payment_id,
				response.razorpay_order_id,
				razOrder.amount/100,
			  );	
             }
          } else {
            toast.error("Payment failed");
          }
      },
        prefill: {
          name: user.name || "Guest",
          email: user.email || "test@example.com",
          contact: user.phone,
        },
        theme: { color: "#533C1D" },
      };

      const rzp = new (window).Razorpay(options);
      rzp.open();
    }else{
     toast.error("Payment failed");
    }
  }
   catch (error) {
    console.error("Payment API Error:", error);
    toast.error("Failed to call payment API");
  }
}

  return (
    <div>
      <div>
      {loaderStatus ? (
        <div className="loader-container">
          {/* <PulseLoader loading={loaderStatus} size={50} color="#0aad0a" /> */}
          <MagnifyingGlass
          visible={true}
          height="100"
          width="100"
          ariaLabel="magnifying-glass-loading"
          wrapperStyle={{}}
          wrapperclassName="magnifying-glass-wrapper"
          glassColor="#c0efff"
          color="#0aad0a"
          />
        </div>
      ) : (
        <>
         <>
            <ScrollToTop/>
            </>
      <>
        {/* section */}
        <section className="mb-lg-14 mb-8 mt-8">
          <div className="container">
            {/* row */}
            <div className="row">
              {/* col */}
              <div className="col-12">
                <div>
                  <div className="mb-8">
                    {/* text */}
                    <h1 className="fw-bold mb-0">Checkout</h1>
                    {/* <p className="mb-0">
                      Already have an account? Click here to{" "}
                      <Link to="/MyAccountSignIn">Sign in</Link>.
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/* row */}
              <div className="row">
                <div className="col-lg-7 col-md-12">
                  {/* accordion */}
                  <div
                    className="accordion accordion-flush"
                    id="accordionFlushExample"
                  >
                    {/* accordion item */}
                    <div className="accordion-item py-4">
                      <div className="d-flex justify-content-between align-items-center">
                        {/* heading one */}
                        <Link
                          to="#"
                          className="fs-5 text-inherit collapsed h4"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseOne"
                          aria-expanded="true"
                          aria-controls="flush-collapseOne"
                        >
                          <i className="feather-icon icon-map-pin me-2 text-muted" />
                          Add delivery address
                        </Link>
                        {/* btn */}
                        <Link
                          to="#"
                          className="btn btn-outline-primary btn-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#addAddressModal"
                        >
                          Add a new address{" "}
                        </Link>
                        {/* collapse */}
                      </div>
                      <div
                        id="flush-collapseOne"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="mt-5">
                          <div className="row">
                            {address?.map((addr,index) =>(
                            <div className="col-lg-6 col-12 mb-4">
                              {/* form */}
                              <div className="border p-6 rounded-3">
                                <div key={index} className="form-check mb-4">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value={index}
                                    checked={selectedAddress==index}
                                    onChange={()=> setSelectedAddress(index)}
                                    name="addresscheck"
                                    id="homeRadio"
                                    defaultChecked
                                  />
                                  <label
                                    className="form-check-label text-dark"
                                    htmlFor="homeRadio"
                                  >
                                    Home
                                  </label>
                                </div>
                                {/* address */}
                                <address>
                                  {" "}
                                  <strong>{addr.name}</strong> <br /> {addr.area} <br />
                                  {addr.city}, {addr.state}, {addr.country}, {addr.pincode},
                                  <br />
                                  <abbr title="Phone">P: {addr.phone}</abbr>
                                </address>
                                {/* <span className="text-danger">
                                  Default address{" "}
                                </span> */}
                              </div>
                            </div>
                            ))}

                            {/* <div className="col-lg-6 col-12 mb-4">
                              <div className="border p-6 rounded-3">
                                <div className="form-check mb-4">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="officeRadio"
                                  />
                                  <label
                                    className="form-check-label text-dark"
                                    htmlFor="officeRadio"
                                  >
                                    Office
                                  </label>
                                </div>
                                <address>
                                  {" "}
                                  <strong>Nitu Chauhan</strong> <br /> 3853 Coal
                                  Road, <br />
                                  Tannersville, Pennsylvania, 18372, USA,
                                  <br />
                                  <abbr title="Phone">P: 402-776-1106</abbr>
                                </address>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* accordion item */}
                    {/* <div className="accordion-item py-4">
                      <Link
                        to="#"
                        className="text-inherit h5"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseThree"
                        aria-expanded="false"
                        aria-controls="flush-collapseThree"
                      >
                        <i className="feather-icon icon-shopping-bag me-2 text-muted" />
                        Delivery instructions
                       {" "}
                      </Link>
                      <div
                        id="flush-collapseThree"
                        className="accordion-collapse collapse "
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="mt-5">
                          <label
                            htmlFor="DeliveryInstructions"
                            className="form-label sr-only"
                          >
                            Delivery instructions
                          </label>
                          <textarea
                            className="form-control"
                            id="DeliveryInstructions"
                            rows={3}
                            placeholder="Write delivery instructions "
                            defaultValue={""}
                          />
                          <p className="form-text">
                            Add instructions for how you want your order shopped
                            and/or delivered
                          </p>
                          <div className="mt-5 d-flex justify-content-end">
                            <Link
                              to="#"
                              className="btn btn-outline-gray-400 text-muted"
                              data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseTwo"
                              aria-expanded="false"
                              aria-controls="flush-collapseTwo"
                            >
                              Prev
                            </Link>
                            <Link
                              to="#"
                              className="btn btn-primary ms-2"
                              data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseFour"
                              aria-expanded="false"
                              aria-controls="flush-collapseFour"
                            >
                              Next
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    {/* accordion item */}
                    <div className="accordion-item py-4">
                      <Link
                        to="#"
                        className="text-inherit h5"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFour"
                        aria-expanded="false"
                        aria-controls="flush-collapseFour"
                      >
                        <i className="feather-icon icon-credit-card me-2 text-muted" />
                        Payment Method
                        {/* collapse */}{" "}
                      </Link>
                      <div
                        id="flush-collapseFour"
                        className="accordion-collapse collapse "
                        data-bs-parent="#accordionFlushExample"
                      >
                      
                        <div className="mt-5">
                            {paymentMethods?.map((method)=>(
                          <div>
                            <div className="card card-bordered shadow-none mb-2">
                              <div className="card-body p-6">
                               
                                <div className="d-flex">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="flexRadioDefault"
                                      id={method.id}
                                      value={method?.id}
                                      checked={selectedPayment == method.id}
                                      onChange={() => setSelectedPayment(method.id)}
                                    />
                                  </div>
                                  <div>
                                    {/* title */}
                                    <h5 className="mb-1 h6">
                                      {" "}
                                     {method.title}
                                    </h5>
                                    <p className="mb-0 small">
                                      {method.desc}
                                    </p>
                                  </div>
                                </div>
                              
                              </div>
                            </div>
                          </div>
                          ))}
                        </div>
                       {/* Button */}
                            <div className="mt-5 d-flex justify-content-end">
                              {/* <Link
                                to="#"
                                className="btn btn-outline-gray-400 text-muted"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseThree"
                                aria-expanded="false"
                                aria-controls="flush-collapseThree"
                              >
                                Prev
                              </Link> */}

                              {selectedPayment == "cod" ?
                              <button className="btn btn-primary ms-2"onClick={handleCreateOrder}>
                                Place Order
                              </button>
                              :
                              <button className="btn btn-primary ms-2"onClick={handlePayment}>
                                Make Payment
                              </button>
                            }
                            </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Order Details */}
                <div className="col-12 col-md-12 offset-lg-1 col-lg-4">
                  <div className="mt-4 mt-lg-0">
                    <div className="card shadow-sm">
                      <h5 className="px-6 py-4 bg-transparent mb-0">
                        Order Details
                      </h5>
                      <ul className="list-group list-group-flush">
                        {/* list group item */}
                        {orderDetails?.products?.map((item=>
                        <Checkout
                        key={item?.id}
                        title={item?.product.iName}
                        image={item?.product?.imgPath?.split(";")[0]}
                        quantity={item?.quantity}
                        price={item?.product.tranRate}
                        unit={item?.product.unit}
                        />
                        ))}
                        
                        {/* list group item */}
                        <li className="list-group-item px-4 py-3">
                          {/* <div className="d-flex align-items-center justify-content-between   mb-2">
                            <div>Item Subtotal</div>
                            <div className="fw-bold">₹{orderDetails?.amount}</div>
                          </div> */}
                          <div className="d-flex align-items-center justify-content-between  ">
                            <div>
                              Delivery Charges{" "}
                              <i
                                className="feather-icon icon-info text-muted"
                                data-bs-toggle="tooltip"
                                title="Default tooltip"
                              />
                            </div>
                            <div className="fw-bold">₹{orderDetails?.delCharge}</div>
                          </div>
                           <div className="d-flex align-items-center justify-content-between  ">
                            <div>
                              Discount{" "}
                              <i
                                className="feather-icon icon-info text-muted"
                                data-bs-toggle="tooltip"
                                title="Default tooltip"
                              />
                            </div>
                            <div className="fw-bold">-₹{orderDetails?.couponAmount}</div>
                          </div>
                        </li>
                        {/* list group item */}
                        <li className="list-group-item px-4 py-3">
                          <div className="d-flex align-items-center justify-content-between fw-bold">
                            <div>Total</div>
                            <div>₹{Number(orderDetails?.amount)}</div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
      <>
        <div>
          {/* Modal */}
          <div
            className="modal fade"
            id="deleteModal"
            tabIndex={-1}
            aria-labelledby="deleteModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="deleteModalLabel">
                    Delete address
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <h6>Are you sure you want to delete this address?</h6>
                  <p className="mb-6">
                    Jitu Chauhan
                    <br />
                    4450 North Avenue Oakland, <br />
                    Nebraska, United States,
                    <br />
                    402-776-1106
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-gray-400"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn btn-danger">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Modal */}
          <form onSubmit={handleAddressSubmit}>
          <div
            className="modal fade"
            id="addAddressModal"
            tabIndex={-1}
            aria-labelledby="addAddressModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                {/* modal body */}
                <div className="modal-body p-6">
                  <div className="d-flex justify-content-between mb-5">
                    {/* heading */}
                    <div>
                      <h5 className="h6 mb-1" id="addAddressModalLabel">
                        New Shipping Address
                      </h5>
                      <p className="small mb-0">
                        Add new shipping address for your order delivery.
                      </p>
                    </div>
                    <div>
                      {/* button */}
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                  </div>
                  {/* row */}
                  <div className="row g-3">
                    
                    <div className="col-12">
                      <input
                        name="name"
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        aria-label="Name"
                        required
                      />
                    </div>
                    
                    {/* <div className="col-12">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Last name"
                        aria-label="Last name"
                        required
                      />
                    </div> */}
                    
                    <div className="col-12">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Address Line 1"
                        name="area"
                      />
                    </div>
                    <div className="col-12">
                      {/* button */}
                      <input
                        name="phone"
                        type="text"
                        className="form-control"
                        placeholder="Phone"
                      />
                    </div>
                    <div className="col-12">
                      {/* button */}
                      <input
                        name="city"
                        type="text"
                        className="form-control"
                        placeholder="City"
                      />
                    </div>
                    <div className="col-12">
                      {/* button */}
                      <input
                        name="state"
                        type="text"
                        className="form-control"
                        placeholder="State"
                      />
                    </div>
                    <div className="col-12">
                      {/* button */}
                      <input
                        name="country"
                        type="text"
                        className="form-control"
                        placeholder="Country"
                      />
                    </div>
                       <div className="col-12">
                      <input
                        name="pincode"
                        type="text"
                        className="form-control"
                        placeholder="Zip Code"
                      />
                    </div>
                    {/* <div className="col-12">                      
                      <select className="form-select">
                        <option selected> India</option>
                        <option value={1}>UK</option>
                        <option value={2}>USA</option>
                        <option value={3}>UAE</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <select
                        className="form-select"
                        aria-label="Default select example"
                      >
                        <option selected>Gujarat</option>
                        <option value={1}>Northern Ireland</option>
                        <option value={2}> Alaska</option>
                        <option value={3}>Abu Dhabi</option>
                      </select>
                    </div> */}
                    
                 
                    {/* <div className="col-12">
                      
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Business Name"
                      />
                    </div> */}
                    {/* <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          defaultValue
                          id="flexCheckDefault"
                        />
                       
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault"
                        >
                          Set as Default
                        </label>
                      </div>
                    </div> */}

             
                    <div className="col-12 text-end">
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary" type="submit" data-bs-dismiss="modal">
                        Save Address
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        </div>
      </>
     </>
    )}
  </div>
    </div>
  );
};

export default ShopCheckOut;
